import translations from '../translations.js';

export function capitalizeString(str, force_lower = false) {
    if (typeof str !== "string") { console.warn("Capitalize err: input not a string."); return ""; }
    if (str.length < 1) { return ""; }

    if (force_lower) {
        return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function translate(str, capitalize = true, language = null, empty_on_error = false) {
    const fallback_language = "en-US";
    const lang_in_jwt = (window.sso && window.sso.isLoggedIn()) ? window.sso.getJWT().getClaim("lang") : fallback_language;
    let lang = language || lang_in_jwt;

    if (!str || str.length === 0) {
        console.error("Tried to translate undefined string.");
        return "";
    }

    let translation = doTranslationCheck(str, translations, lang, fallback_language, empty_on_error);

    if (capitalize === true) {
        return capitalizeString(translation);
    }
    return translation;
}

export function translateServiceName(service_name, capitalize = true, language = null) {
    let lang = language || window.sso.getJWT().getClaim("lang");
    const fallback_language = "en-US";

    if (!service_name || service_name.length < 1) {
        console.error("Tried to translate service name without specifying service_name");
    }

    let translation = doTranslationCheck(service_name, window.sso.specs.translations.services, lang, fallback_language);

    if (capitalize === true) {
        return capitalizeString(translation);
    }
    return translation;
}

export function translateFromSSOSpecs(claim_key, library, capitalize = true, language = null) {
    let lang = language || window.sso.getJWT().getClaim("lang");
    const fallback_language = "en-US";

    if (!claim_key || claim_key.length === 0) {
        console.error("Tried to translate undefined claim_key.");
        return "";
    }

    let translation = doTranslationCheck(claim_key, library, lang, fallback_language);

    if (capitalize === true) {
        return capitalizeString(translation);
    }
    return translation;
}

function doTranslationCheck(key, library, lang, fallback_language, empty_on_error = false) {
    if (library.hasOwnProperty(lang) === false) {
        console.warn("Translation for language '" + lang +"' not supported, defaulting to: " + fallback_language);
        lang = fallback_language;
    }

    let translation = library[lang][key];
    if (!translation) {
        if (lang === fallback_language) {
            console.error("No translation found for '" + key + "' for '" + lang + "' or fallback language.");
            if (empty_on_error) {
                return "";
            }
            return key + "";
        }

        translation = translations[fallback_language][key];
        if (!translation) {
            console.error("No translation found for '" + key + "' for '" + lang + "' or fallback language.");
            if (empty_on_error) {
                return "";
            }
            return key + "";
        }

        console.warn("No translation found for '" + key + "' for '" + lang + "'. Returning fallback language.");
    }

    return translation;
}



// WEBPACK FOOTER //
// ./src/helpers/output_helpers.js